export const dataUrl = '/srm-api'
export const publicUrl = '/srm-public'
export const base = ''
